import { createClient } from "pexels";
// import axios from "axios";
import {
  GET_IMAGES_QUERY,
  GET_PRESIGNED_URLS_QUERY,
} from "../queries/getImagesQuery";
import { GET_MEDIAINDEX_TAGS_QUERY } from "../queries/getMediaIndexTagsQuery"; // Correct import path
import { client } from "../apolloClient"; // Apollo client instance

const pexelsClient = createClient(
  "ldTfo8pDJ6KkzCEVyITzBLrbzyKKcrVNwrVQm2utrLQIHk35ye8fWtd7"
);

// Fetch images from GraphQL API
export const getImagesApi = async (payload) => {
  // console.log(
  //   `PMM - SF - mediaApi.js - getImagesApi payload is: ${JSON.stringify(
  //     payload
  //   )}`
  // );

  try {
    const response = await client.query({
      query: GET_IMAGES_QUERY, // Use the GraphQL query to fetch images
      variables: { input: payload }, // Pass the payload as "input"
    });

    return response;
  } catch (error) {
    // console.error(
    //   `PMM - SF - mediaApi.js - Error fetching images: ${error.message}`
    // );
    throw error;
  }
};

export const getPexelsImagesApi = async (payload) => {
  // console.log(
  //   `PMM - SF - mediaApi.js - getPexelsImagesApi payload is: ${JSON.stringify(
  //     payload
  //   )}`
  // );
  const query = payload;
  try {
    const response = await pexelsClient.photos.search({ query, per_page: 6 });
    return response;
  } catch (error) {
    console.log(error);
  }
  // pexelsClient.photos
  //   .search({ query, per_page: 6 })
  //   .then((response) => {
  //     const photos = response.photos;
  //     console.log(
  //       `PMM - SF - api - returning photos length is: ${JSON.stringify(
  //         photos.length
  //       )}`
  //     );
  //     return response;
  //     console.log(`PMM - SF - api - returned the photos`);
  //   })
  //   .catch((error) => {
  //     console.log(
  //       `PMM - SF - getPexelsImagesApi - catch hit - error is: ${JSON.stringify(
  //         error
  //       )}`
  //     );
  //     console.log(error);
  //   });
  // .then(function () {
  //   console.log(
  //     `PMM - SF - getPexelsImagesApi - initiated final then clause`
  //   );
  //   // always executed
  // });

  // axios
  //   .get(`https://jsonplaceholder.typicode.com/users`)
  //   .then((res) => {
  //     const persons = res.data;
  //     setPerson(persons);
  //   })
  //   .catch((error) => {
  //     console.log(error);
  //   })
  //   .then(function () {
  //     // always executed
  //   });
};

export const fetchPresignedUrlsFromApi = async (fileNames) => {
  console.log(
    `PMM - SF - api - fetchPresignedUrlsFromApi - fetching URLs for fileNames: ${JSON.stringify(
      fileNames
    )}`
  );

  try {
    const apiPayload = {
      query: GET_PRESIGNED_URLS_QUERY,
      variables: {
        input: {
          operationType: "GET_THUMBNAIL_URLS",
          entityType: "IMAGE",
          fileNames,
          tenantId: "instant-startup-ai",
        },
      },
    };
    console.log(
      `PMM - SF - api - fetchPresignedUrlsFromApi - apiPayload: ${JSON.stringify(
        apiPayload
      )}`
    );
    const response = await client.query(apiPayload);

    console.log(
      `PMM - SF - imageApi.js - fetchPresignedUrlsfromApi - response is: ${JSON.stringify(
        response
      )}`
    );
    const presignedUrls = response.data.getPresignedUrls.presignedUrls;
    console.log(
      `PMM - SF - imageApi.js - fetchPresignedUrlsfromApi - response is: ${JSON.stringify(
        response
      )}`
    );
    return presignedUrls;
  } catch (error) {
    console.log(
      `PMM - SF - imageApi.js - fetchPresignedUrlsfromApi - catch hit! - error is: ${JSON.stringify(
        error
      )}`
    );
    console.error("Error fetching pre-signed URLs:", error);
    throw error;
  }
};

export const fetchPresignedPutUrlsFromApi = async (fileNames) => {
  console.log(
    `PMM - SF - api - fetchPresignedPutUrlsFromApi - fetching URLs for fileNames: ${JSON.stringify(
      fileNames
    )}`
  );

  try {
    const apiPayload = {
      query: GET_PRESIGNED_URLS_QUERY,
      variables: {
        input: {
          operationType: "GET_PRESIGNED_URLS",
          entityType: "IMAGE",
          fileNames,
          tenantId: "instant-startup-ai",
        },
      },
    };
    console.log(
      `PMM - SF - api - fetchPresignedPutUrlsFromApi - apiPayload: ${JSON.stringify(
        apiPayload
      )}`
    );
    const response = await client.query(apiPayload);

    console.log(
      `PMM - SF - imageApi.js - fetchPresignedPutUrlsFromApi - response is: ${JSON.stringify(
        response
      )}`
    );
    const presignedUrls = response.data.getPresignedUrls.presignedUrls;
    console.log(
      `PMM - SF - imageApi.js - fetchPresignedPutUrlsFromApi - response is: ${JSON.stringify(
        response
      )}`
    );
    return presignedUrls;
  } catch (error) {
    console.log(
      `PMM - SF - imageApi.js - fetchPresignedPutUrlsFromApi - catch hit! - error is: ${JSON.stringify(
        error
      )}`
    );
    console.error("Error fetching pre-signed URLs:", error);
    throw error;
  }
};

// Fetch tags from MEDIAINDEX
export const getTagsApi = async (payload) => {
  // console.log(
  //   `PMM - SF - mediaApi.js - getTagsApi payload is: ${JSON.stringify(payload)}`
  // );

  try {
    const response = await client.query({
      query: GET_MEDIAINDEX_TAGS_QUERY, // Use the GraphQL query to fetch media index tags
      variables: { input: payload },
    });

    // console.log(
    //   `PMM - SF - mediaApi.js - getTagsApi response is: ${JSON.stringify(
    //     response
    //   )}`
    // );
    return response;
  } catch (error) {
    console.error(
      `PMM - SF - mediaApi.js - Error fetching tags: ${error.message}`
    );
    throw error;
  }
};
